import axios from "../axios";
import h from "../helpers";

const shipmentCostCategory = {
  index: async () => {
    const { data } = await axios.get(h.baseUrl("delivery-category"));
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("delivery-category/" + id));
    return data;
  },
  store: async (name, price, DeliveryDiscounts) => {
    const { data } = await axios.post(
      h.baseUrl('delivery-category'),
      { name, price, DeliveryDiscounts },
    );
    return data;
  },
  update: async (id, name, price, DeliveryDiscounts) => {
    const { data } = await axios.put(
      h.baseUrl('delivery-category/' + id),
      { name, price, DeliveryDiscounts },
    );
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(
      h.baseUrl('delivery-category/' + id),
    );
    return data;
  },
};

export default shipmentCostCategory;
